import { Profile } from '~/helpers/userProfile';
import { ThermalComfortStatusFilter } from '~/providers/types/overview';
import { colors } from '~/styles/colors';
import { ThermalComfortCountInfo, ThermalComfortUnitsInfo } from '../contexts/ThermalComfortDataContext';
import { ThermalComfortVariant } from '../ThermalComfort/components/UnitsInfo/types';
import { DayThermalComfortInfo, MonthThermalComfortInfo, ThermalComfortHistoryInfo } from '../ThermalComfort/types';
import { GetOverviewThermalComfort, GetThermalComfortHistory } from '../types';

export function canViewThermalComfort(profile: Profile): boolean {
  return !!profile.manageAllClients;
}

export function parseThermalComfortData(data: GetOverviewThermalComfort): ThermalComfortCountInfo {
  return {
    aboveLimit: data.COUNT_TOTAL_ABOVE_LIMIT_UNITS,
    belowLimit: data.COUNT_TOTAL_BELOW_LIMIT_UNITS,
    comfortable: data.COUNT_TOTAL_COMFORTABLE_UNITS,
    inoperative: data.COUNT_TOTAL_INOPERANT_UNITS,
  };
}

export function parseUnits(data: GetOverviewThermalComfort['UNITS']): ThermalComfortUnitsInfo {
  return data.map((item) => ({
    id: item.UNIT_ID,
    lat: item.UNIT_LAT ? Number(item.UNIT_LAT) : null,
    lon: item.UNIT_LON ? Number(item.UNIT_LON) : null,
    name: item.UNIT_NAME,
    state: item.STATE_NAME,
    city: item.CITY_NAME,
    thermalComfort: parseUnitThermalComfortStatus(item.UNIT_STATUS),
    environments: {
      aboveLimit: item.COUNT_ABOVE_LIMIT_ENVIRONMENTS,
      belowLimit: item.COUNT_BELOW_LIMIT_ENVIRONMENTS,
      comfortable: item.COUNT_COMFORTABLE_ENVIRONMENTS,
      inoperative: item.COUNT_INOPERANT_ENVIRONMENTS,
      outsideOperatingHours: item.COUNT_OUTSIDE_OPERATING_HOURS_ENVIRONMENTS,
    },
  }));
}

export function parseHistoryData(data: GetThermalComfortHistory): ThermalComfortHistoryInfo {
  return {
    TYPE: data.TYPE,
    HISTORY: [...data.HISTORY].reverse(),
  } as DayThermalComfortInfo | MonthThermalComfortInfo;
}

export function parseUnitThermalComfortStatus(unitStatus: ThermalComfortStatusFilter): ThermalComfortVariant {
  switch (unitStatus) {
    case 'above_limit': return 'aboveLimit';
    case 'below_limit': return 'belowLimit';
    case 'comfortable': return 'comfortable';
    default: return 'inoperative';
  }
}

export function parseThermalComfortColor(thermalComfort: ThermalComfortVariant): string {
  switch (thermalComfort) {
    case 'aboveLimit': return colors.state.danger.base;
    case 'belowLimit': return colors.state.cold.base;
    case 'comfortable': return colors.state.success.base;
    default: return colors.icon['soft-400'];
  }
}
